import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { User } from 'components/common';
import { Box } from 'components/common/box';
import { ProfileAmbitionsEdit, ProfileBadges } from '.';

import type { RequestUser } from 'shared-types';
import type { GetUsersRes } from 'shared-types/responses';
import type { BadgeCategory } from 'components/common/Badge';

interface Props {
  isPreview?: boolean;
  isUserPage: boolean;
  targetUser: RequestUser;
}

const ProfileAmbitions = ({ isPreview, isUserPage, targetUser }: Props) => {
  const { messages, theme, user: loggedInUser } = useReduxState();

  const { data, updateData } = useApiData<GetUsersRes>({
    url: `/admin/users?id=${targetUser?.id}`,
    onlyIf: Boolean(targetUser?.id)
  });

  const ambitions = data?.users?.[0]?.ambitions?.map((ambition) => ({
    category: 'default' as BadgeCategory,
    icon: 'flag' as const,
    title: ambition.title,
    tooltipContent: ambition.addedBy ? (
      <div>
        <div style={{ color: theme.textColorLighter, marginBottom: 5 }}>
          {messages.commonAddedBy}
        </div>
        <User
          enableProfileLink={isUserPage}
          user={ambition.addedBy}
          size="small"
        />
      </div>
    ) : null
  }));

  const loggedInUserHasEditPermissions =
    loggedInUser?.roles.includes('superadmin') ||
    (loggedInUser?.roles.includes('admin') &&
      loggedInUser?.permissions.includes('manage-users'));

  return (
    <Box
      headerContent={
        !isPreview && (loggedInUserHasEditPermissions || !isUserPage) ? (
          <ProfileAmbitionsEdit
            ambitions={ambitions?.map((ambition) => ambition.title) || []}
            targetUserId={targetUser.id}
            updateAmbitions={updateData}
          />
        ) : null
      }
      title={messages.analyticsAmbitions}
    >
      <ProfileBadges
        emptyMessage={messages.commonNoAmbitions}
        id="profile-ambitions"
        items={ambitions}
      />
    </Box>
  );
};

export default ProfileAmbitions;
